// @flow
const shared = "font-size: 14px; line-height: 1.5; color: #fff;";

const styles = {
  error: `${shared} background: maroon;`,
  log: `${shared} background: navy;`
};

export function log(log: string) {
  return console.log(`%c ${log} `, styles.log);
}

export function error(error: string) {
  return console.log(`%c ${error} `, styles.error);
}



// WEBPACK FOOTER //
// ./src/components/common/customConsole.js